import React from 'react';
import './index.css';
import './Bootstrap/css/bootstrap.css';
import Navbar from './Navbar';

export default function Contact() {
	return (
		<div className="container-md">
			<Navbar />
			
			<h2 style={{fontFamily: "Times, Times New Roman, serif", marginLeft: "10px", color: "#2556A6", fontWeight: "bold"}}>Contact Us</h2>
			<hr />
			
			<div className="row" style={{marginTop: "20px", marginBottom:"20px", textAlign:"center"}}>
				<p className="h4 content">DOTDIP Solution Inc.</p>
				<p className="h4 content">Unit 2006, 77 Harbour Sq, Toronto, ON, M5J 2S2</p>
				{/* <a className="h4 content" href="mailto:info@dotdip.ca?subject=Subject&body=Message%20Us%20Your%20Needs">Email Us</a> */}
				<p className="h4 content">info@dotdip.ca</p>
			</div>
			
 			<div className="container footer-bar">
				<p>© Copyright 2026 - DOTDIP Solutions Inc.</p>
			</div>
 			
		</div>
	);
}